<template>
  <div class="detail">
    <dl class="display_flex">
      <dt class="cover_box">
        <img :src="details.img" alt="商品图片" class="cover">
      </dt>
      <dd>
        <p class="ellipsis2" :title="details.name"><span v-if="details.labelName" :class="[details.label === '1' ? 'hot' : 'new']">{{ details.labelName }}</span>{{ details.name }}
        </p>
        <div class="description ellipsis2" :title="details.description">{{ details.description }}</div>
        <!-- 价值 X豆 -->
        <div class="points"><span class="price">{{ thousandSeparator(details.redeemPrice, 1000) }}</span>{{ details.redeemWayName }}<span class="already">已售：{{ details.sales || 0 }}</span></div>
        <div class="stepper display_flex alignItems_center">
          <div class="label">数量</div>
          <!-- :disabled="form.redeemNum <= 0" @click="form.redeemNum > 0 && form.redeemNum--" -->
          <el-button icon="el-icon-minus" disabled></el-button>
          <!-- 步进器 -->
          <span class="num">{{ form.redeemNum }}</span>
          <!-- :disabled="form.redeemNum >= 3" -->
          <!-- form.redeemNum < 3 && -->
          <el-button icon="el-icon-plus" @click="handleAdd" disabled></el-button>
          <!-- <div class="inventory">剩余：999</div> -->
        </div>
        <!-- :disabled="form.redeemNum <= 0" -->
        <el-button type="primary" @click="handleSubmit">兑换</el-button>
      </dd>
    </dl>
    <div class="detail_info">
      <ul class="display_flex alignItems_center">
        <li @click="handleTab(item.key)" :class="{'active': item.key === tabIndex }"
            v-for="item in tabList" :key="item.key">{{ item.value }}</li>
      </ul>
      <div class="detail_info_row">
        <template v-if="tabIndex === 1">
          <div class="rows display_flex" v-for="(item, idx) in infoList" :key="idx">
            <span class="label">{{ item.label }}</span>
            <span class="value">{{ item.value }}</span>
          </div>
        </template>
        <div v-if="tabIndex === 2" v-html="details.productDetail"></div>
      </div>
      <Empty v-if="tabIndex === 2 && !details.productDetail" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Empty from '@/components/empty/index.vue'
import { initTime, thousandSeparator } from '@/utils/index.js'
import detailsMixin from '../mixins/detailsMixin'

export default {
  mixins: [detailsMixin],
  components: {
    Empty
  },
  props: {
  },
  data () {
    return {
      form: {
        productId: null, // 商品id
        orderNo: initTime(new Date().getTime(), 'YYYYMMDDHHmmss'),
        redeemNum: 1, // 兑换数量
        redeemConsume: 0, // 兑换消耗
        redeemTime: initTime(new Date().getTime(), 'YYYY-MM-DD HH:mm:ss'), // 兑换时间
        orderStatus: 1
      },
      tabList: [{
        value: '商品信息',
        id: 1,
        key: 1
      }, {
        value: '图文详情',
        id: 2,
        key: 2
      }],
      tabIndex: 1,
      inventory: 1
    }
  },
  computed: {
    infoList () {
      const d = this.details
      let projectObj = []
      if (d.productAttribute !== '1') {
        projectObj = [
          { label: '企业名称', value: `${d.organId} ${d.organName}` || '-' },
          { label: '项目名称', value: `${d.groupId} ${d.groupName}` || '-' }
        ]
      }
      return [
        ...projectObj,
        { label: '商品名称', value: d.name || '-' },
        { label: '提供商家', value: d.merchant || '-' },
        { label: '规格', value: d.specificationsName || '-' },
        { label: '类型', value: d.productTypeName || '-' },
        { label: '核心特点', value: d.description || '-' },
        { label: '使用限制', value: '不可兑现、不可退换，不支持购买第三方卖家商品，下单时直接抵扣订单金额' }
      ]
    },
    ...mapGetters(['userInfo'])
  },
  methods: {
    thousandSeparator,
    handleAdd () {
      if (this.form.redeemNum >= this.inventory) {
        this.$message.warning('库存不足！')
        return
      }
      this.form.redeemNum++
    },
    async handleSubmit () {
      // const x = 1
      // if (this.details.redeemWay === '1' && x < (this.details.redeemPrice * this.form.redeemNum)) return this.$message.warning(`可用${this.details.redeemWayName}不足！`)
      const data = await this.handleVerify()
      if (data) {
        this.$router.push({ path: '/orderDetail', query: { id: this.form.productId, num: this.form.redeemNum } })
      }
    },
    handleTab (index) {
      this.tabIndex = index
    }
  },
  mounted () {
    this.form.productId = this.$route.query.id
  }
}
</script>
<style lang="less" scoped>
.detail {
  width: 1200px;
  min-height: calc(100vh - 52px);
  padding: 40px 0px 20px;
  margin: 0 auto;
  dl{
    dt{
      width: 476px;
      min-width: 476px;
      // padding: 70px;
      text-align: center;
      background: #f5f7fb;
      border-radius: 12px;
      .cover {
        width: 100%;
        height: 476px;
        object-fit: cover;
        border-radius: 12px;
      }
    }
    dd {
      margin: 0;
      padding: 12px 0 16px 20px;
      p {
        font-size: 24px;
        font-weight: 500;
        color: #121826;
        span {
          display: inline-block;
          padding: 2px 8px;
          border-radius: 4px;
          margin-right: 8px;
          font-size: 20px;
          transform: translateY(-1px);
        }
        .hot {
          background: #f7615c;
          color: #ffffff;
        }
        .new {
          border: 1px solid #5078d7;
          color: #3b5fba;
        }
      }
      .description {
        font-size: 15px;
        color: #999ba2;
        margin: 8px 0 25px;
      }
      .points {
        font-size: 14px;
        color: #515767;
        .price {
          font-weight: 600;
          font-size: 28px;
          color: #f7615c;
          padding: 0 6px 0 0;
        }
        .already{
          font-size: 14px;
          color: #999BA2;
          margin-left: 12px;
        }
      }
      .stepper {
        font-size: 14px;
        color: #999ba2;
        margin-top: 24px;
        .label {
          width: 56px;
          padding: 8px 0;
        }
        .el-button{
          padding: 9px;
          background: #F5F7FB;
          border: 1px solid #F2F2F5;
          font-size: 12px;
        }
        .num{
          padding: 0 16px;
          color: #121826;
          font-size: 18px;
        }
        .inventory {
          margin-left: 16px;
        }
      }
      >.el-button{
        padding: 15px 169px;
        border-radius: 12px;
        margin-top: 24px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #fff;
        margin-top: 194px;
      }
      .el-button--primary:not(.is-disabled) {
        background-color: #3b5fba;
        border-color: #3b5fba;
      }
    }
  }
  .detail_info {
    > ul {
      margin: 32px 0 3px;
      li {
        font-weight: 500;
        font-size: 16px;
        color: #999ba2;
        padding: 7px 16px;
        cursor: pointer;
        position: relative;
      }
      .active {
        color: #121826;
        &::after {
          content: ' ';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 12px;
          height: 3px;
          background: #3b5fba;
          border-radius: 1px;
        }
      }
    }
    .detail_info_row {
      margin-top: 12px;
      display: flex;
      flex-wrap: wrap;
      padding: 0 0 0 16px;
      .rows {
        width: 33.3%;
        align-items: baseline;
        gap: 24px;
        padding: 12px 0;
        // margin-top: 20px;
        font-size: 14px;
        .label {
          flex: 0 0 56px;
          color: #999ba2;
        }
        .value {
          color: #121826;
          transform: translateY(-0.8px);
          padding-right: 20px;
        }
      }
    }
  }
}
.ellipsis2{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
</style>
